/* eslint-disable @typescript-eslint/naming-convention */
export enum ReminderTopic {
  BANK_LOAN = 'Bank Loan',
  INVESTMENT = 'Investment',
  AUDIT = 'Audit',
  TAX = 'Tax',
  LEGAL = 'Legal',
  EXPENSE = 'Expense',
  INTERCOMPANY_BALANCE = 'Intercompany Balance',
  D_AND_O_INSURANCE = 'D&O Insurance',
  OTHER = 'Other',
}
